<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar';
import { useI18n } from 'vue-i18n';

import HomepageItemSelectionTable from '@/components/HomepageItemSelectionTable.vue';
import type { Locales } from '@/services/types/api.types';

// PROPS
const props = defineProps<{
  itemType: number | null;
  title: string;
  languageEnabled: Locales[];
}>();

// EMITS
const emit = defineEmits([...useDialogPluginComponent.emits]);

// CONST
const { t } = useI18n();
const { dialogRef, onDialogHide, onDialogCancel } = useDialogPluginComponent();

// FUNCTIONS
function handleRowClick(row: any) {
  emit('ok', row);
  dialogRef.value?.hide();
}
</script>
<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <q-card class="q-dialog-plugin" style="width: 600px">
      <q-card-section class="row">
        <div class="text-h6">{{ props.title }}</div>
        <q-space />
      </q-card-section>
      <q-separator />
      <q-card-section>
        <homepage-item-selection-table
          :item-type="itemType"
          @row-click="handleRowClick"
          :language-enabled="props.languageEnabled"
        />
      </q-card-section>
      <q-separator />
      <q-card-actions align="right">
        <q-btn color="primary" flat :label="t('global.cancel')" @click="onDialogCancel" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
